import { render, staticRenderFns } from "./CommunityLibrary.vue?vue&type=template&id=53fb9559&scoped=true"
import script from "./CommunityLibrary.vue?vue&type=script&lang=js"
export * from "./CommunityLibrary.vue?vue&type=script&lang=js"
import style0 from "./CommunityLibrary.vue?vue&type=style&index=0&id=53fb9559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb9559",
  null
  
)

export default component.exports